import { useCurrentOrganization } from '@shared/hooks';
import { useClientPreferencesContext } from '@shared/hooks/useClientPreferencesContext';

const useProjectVisibilityOptions = () => {
  const currentOrganization = useCurrentOrganization();
  const { accessOnlyForLoggedInUsers } = useClientPreferencesContext();

  const publicForLoggedInDescription = currentOrganization?.name
    ? `Everyone at ${currentOrganization?.name} can see this project`
    : 'Everyone with an account can see this project';

  return {
    public: accessOnlyForLoggedInUsers
      ? publicForLoggedInDescription
      : 'Anyone on the internet can see this project',
    private: 'You choose who can see experiments for this project'
  };
};

export default useProjectVisibilityOptions;
